import {hashObject} from "@cm/utils"
import type {IMaterialData} from "#material/types/material-data"

export function keyForMaterialData(materialData: IMaterialData): string {
    return hashObject({
        uniqueId: materialData.materialGraph.uniqueId,
        side: materialData.side,
        alphaMaskThreshold: materialData.alphaMaskThreshold,
        disable: materialData.realtimeSettings?.disable,
        textureResolution: materialData.realtimeSettings?.textureResolution,
        textureFiltering: materialData.realtimeSettings?.textureFiltering,
        textureStreamingMode: materialData.realtimeSettings?.textureStreamingMode,
        alphaHashing: materialData.realtimeSettings?.alphaHashing,
    })
}
